import {
    Component,
    ViewChild,
    TemplateRef,
    OnInit,
    OnDestroy,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
// -- components --
import { SubTabsComponent } from '../components/sub-tabs/sub-tabs.component';
import { Step1Component } from './components/step-1/step-1.component';
import { Step2Component } from './components/step-2/step-2.component';
import { Step3Component } from './components/step-3/step-3.component';
// -- models --
import { TabOption } from '../components/sub-tabs/sub-tabs.component';
// -- services --
import { Jc3Service } from '../jc3.service';
import { TabNavigationHandlerService } from '../services/tab-navigation-handler.service';

interface CapacityCard {
    formid: number;
    imagemobile: string;
    imagedesktop: string;
    imagetablet: string;
    switchergroup: string;
    institution: string;
    cta: string;
    id: number;
    description: string;
    title: string;
    publishdate: string;
    url: string;
    formalias: string;
    category?: string;
}

interface CapacityBuilding {
    formid: number;
    swither2alias: string;
    id: number;
    switcher3: string;
    swither3alias: string;
    switcher1: string;
    switcher2: string;
    swither1alias: string;
    description: string;
    title: string;
    formalias: string;
}

interface CapacityResponse {
    capacityBuilding: CapacityBuilding[];
    'capacityBuilding-children': Array<{ capacityCards: CapacityCard[] }>;
}

@Component({
    selector: 'app-capacity-building',
    standalone: true,
    imports: [
        TranslateModule,
        CommonModule,
        SubTabsComponent,
        Step1Component,
        Step2Component,
        Step3Component,
    ],
    providers: [TabNavigationHandlerService],
    templateUrl: './capacity-building.component.html',
    styleUrl: './capacity-building.component.scss',
})
export class CapacityBuildingComponent implements OnInit, OnDestroy {
    capacityData: any = null;
    capacityInfo: CapacityBuilding | null = null;
    tabs: TabOption[] = [];
    cpCards: any = [];
    step1data = [];
    step2data = [];
    step3data = [];

    @ViewChild('step1') step1!: TemplateRef<any>;
    @ViewChild('step2') step2!: TemplateRef<any>;
    @ViewChild('step3') step3!: TemplateRef<any>;

    constructor(
        private _jc3Service: Jc3Service,
        public tabHandler: TabNavigationHandlerService
    ) {}

    ngOnInit(): void {
        this.tabHandler.initialize({
            mainTabName: 'capacity-building',
            tabs: this.tabs,
        });
        this.getCapacityData();
        this.getCapacityCards();
    }

    ngOnDestroy(): void {
        this.tabHandler.ngOnDestroy();
    }

    getCapacityData(): void {
        this._jc3Service.getCapacityTitleSwitcher().subscribe({
            next: (res: any) => {
                this.capacityData = res?.at(0);
                this.setupTabs();
            },
            error: (err) => {
                console.log(err);
            },
        });
    }

    getCapacityCards(): void {
        this._jc3Service.getCapacityCards().subscribe({
            next: (res: any) => {
                this.cpCards = res;
                this.step1data =
                    this.getCardsForSwitcherGroup('TRAININGPROGRAMMES');
                this.step2data = this.getCardsForSwitcherGroup('TOOLSRE');
                this.step3data = this.getCardsForSwitcherGroup('CONSEM');
            },
            error: (err) => {
                console.log(err);
            },
        });
    }

    private setupTabs(): void {
        if (!this.capacityData) return;

        this.tabs = [
            {
                label: this.capacityData.switcher1,
                value: 'TRAININGPROGRAMMES',
                // value: this.capacityData?.switcher1alias?.toLowerCase(),
                template: this.step1,
            },
            {
                label: this.capacityData.switcher2,
                value: 'TOOLSRE',
                // value: this.capacityData?.switcher2alias?.toLowerCase(),
                template: this.step2,
            },
            {
                label: this.capacityData.switcher3,
                value: 'CONSEM',
                // value: this.capacityData?.switcher3alias?.toLowerCase(),
                template: this.step3,
            },
        ];

        // Update tabs in the handler service
        this.tabHandler.updateTabs(this.tabs);
    }

    getCardsForSwitcherGroup(switcherGroup: string): CapacityCard[] {
        if (!this.cpCards) return [];

        const today = new Date();

        return this.cpCards.filter((card) => {
            const publishDate = new Date(card.publishdate);
            return card.switchergroup === switcherGroup && publishDate <= today;
        });
    }
}
